import { CoinListItem } from '../types';

export const METAL_IDS = ['xau-gold', 'xag-silver'] as const;
export type MetalId = typeof METAL_IDS[number];

export interface MetalDisplay {
  label: string;
  color: string;
  bg: string;
  border: string;
}

export const METAL_DISPLAY: Record<string, MetalDisplay> = {
  'xau-gold':   { label: 'Au', color: '#B8860B', bg: '#FFD70018', border: '#FFD70045' },
  'xag-silver': { label: 'Ag', color: '#909090', bg: '#C0C0C018', border: '#C0C0C045' },
};

export const METALS: CoinListItem[] = [
  {
    id: 'xau-gold',
    symbol: 'XAU',
    name: 'Gold',
    image: '',
    marketCapRank: 0,
    currentPrice: 0,
    marketCap: 0,
    volume24h: 0,
    high24h: 0,
    low24h: 0,
  },
  {
    id: 'xag-silver',
    symbol: 'XAG',
    name: 'Silver',
    image: '',
    marketCapRank: 0,
    currentPrice: 0,
    marketCap: 0,
    volume24h: 0,
    high24h: 0,
    low24h: 0,
  },
];

export function isMetal(id: string): id is MetalId {
  return (METAL_IDS as readonly string[]).includes(id);
}
